import { Spinner } from './admin/spinner';

type AppLoadingProps = {
  isError?: boolean;
};

/**
 * Full-screen loading / error state. Also rendered before react-admin is ready (no i18n provider, no
 * theme toggle yet), so the texts are literal English.
 */
export const AppLoading = ({ isError }: AppLoadingProps) => {
  return (
    <div className="flex h-screen items-center justify-center text-center">
      {isError ? (
        <div>
          <p className="font-bold">Error loading app.</p>
          <p>Please contact Moonstar support if problem persists.</p>
        </div>
      ) : (
        <Spinner size="large" className="size-16" />
      )}
    </div>
  );
};
